export const tokenUpdate = (token) => ({type: 'TOKEN', token: token})